import { Component, Inject, OnInit } from '@angular/core';
import { Cloudinary, LocalStorage, XmStore, XmStoreUtil } from 'core/services';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { User } from 'store/user/models';
import { CmsMyAccountModals } from 'store/cms/models';

@Component({
    selector: 'xm-accouncement',
    styleUrls: ['./announcement.scss'],
    templateUrl: './announcement.html',
    standalone: false
})
export class XmMyAccountAnnouncements implements OnInit {
    public pageData: CmsAnnouncementModal;
    public icon: MediaImageOptions;
    public announcementArray: Announcement[];
    public carousalSettings: XmSwiperOptions = {
        id: 'plan-options-carousel',
        slidesPerView: 1,
        slidesPerGroup: 1,
        showArrows: true,
        outsideArrows: true,
        navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next'
        },
        breakpoints: {
            959: {
                slidesPerView: 1,
                slidesPerGroup: 1
            }
        }
    };
    public isDismissable: boolean = false;

    private dialogRef: MatDialogRef<XmMyAccountAnnouncements>;
    private localStorage: LocalStorage;
    private subscriptions: Subscription[] = [];
    private xmStore: XmStore;
    private customerId: string;

    constructor(xmStore: XmStore, dialogRef: MatDialogRef<XmMyAccountAnnouncements>, localStorage: LocalStorage, @Inject(MAT_DIALOG_DATA) announcementArray: Announcement[]
    ) {
        Object.assign(this, { xmStore, dialogRef, localStorage, announcementArray });
    }

    public ngOnInit(): void {
        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsMyAccountModals>(CmsMyAccountModals), (result: CmsMyAccountModals) => {
            this.pageData = result.modals.announcement;
        }));
        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<User>(User), (user: User) => {
            this.customerId = user.account.customerId;
        }));
        this.icon = {
            mobile: Cloudinary.generateMediaFromCms(this.announcementArray[0].content.icon)
        };
        this.announcementSeen(0);
    }

    public announcementSeen(slideIndex: number): void {
        this.isDismissable = slideIndex === this.announcementArray.length - 1;
        const announcement: Announcement = this.announcementArray[slideIndex];
        if (!announcement.alwaysShow && !announcement.countUpdated) {
            const custAnnouncementString: string = this.customerId + announcement.announcmentId;
            const seenAnnouncementObj: object = this.localStorage.hasKey('seenAnnouncement') ? JSON.parse(atob(this.localStorage.get('seenAnnouncement'))) : {};
            const timesToShow: number = seenAnnouncementObj[custAnnouncementString] ? seenAnnouncementObj[custAnnouncementString] : announcement.timesToShow;
            seenAnnouncementObj[custAnnouncementString] = timesToShow > 0 ? timesToShow - 1 : 0;
            this.localStorage.set('seenAnnouncement', btoa(JSON.stringify(seenAnnouncementObj)));
            announcement.countUpdated = true;
        }
    }

    public toggleDoNotShow(announcement: Announcement): void {
        announcement.doNotShow = !announcement.doNotShow;
    }

    public close(): void {
        this.removeDoNotShowAnnouncements();
        this.dialogRef.close();
    }

    private removeDoNotShowAnnouncements(): void {
        this.announcementArray.forEach((announcement: Announcement) => {
            if (announcement.doNotShow) {
                const seenAnnouncementObj: object = this.localStorage.hasKey('seenAnnouncement') ? JSON.parse(atob(this.localStorage.get('seenAnnouncement'))) : {};
                const custAnnouncementString: string = this.customerId + announcement.announcmentId;
                seenAnnouncementObj[custAnnouncementString] = 0;
                this.localStorage.set('seenAnnouncement', btoa(JSON.stringify(seenAnnouncementObj)));
            }
        });
    }
}
